import React, { useState, useEffect } from 'react';
import { Icon } from '@iconify/react';
import api from '../../services/api';
import { toast } from 'react-toastify';

const UnitCountOne = () => {
    const [insights, setInsights] = useState(null);

    // Determine user type (admin or developerSales) from localStorage
    const storedUser = localStorage.getItem("user");
    const userType = storedUser ? JSON.parse(storedUser).type : null;

    useEffect(() => {
        // Decide which endpoint to call based on user type
        const endpoint = userType === "admin"
            ? "insights/adminInsights"
            : "insights/developerInsights";

        api.get(endpoint)
            .then((res) => {
                if (res.data.response) {
                    setInsights(res.data.response);
                }
            })
            .catch((e) => console.log(e));
    }, [userType]);

    if (!insights) {
        // If insights are not yet loaded, show nothing or a loading indicator
        return null;
    }
    const formatNumber = (number) => {
        if (number >= 1000) {
            return new Intl.NumberFormat().format(number);
        }
        return number.toString();
    };
    return (
        <div className="row row-cols-xxxl-5 row-cols-lg-3 row-cols-sm-2 row-cols-1 gy-4">

          {/* ----- ADMIN CARDS ----- */}
{userType === "admin" && (
    <>
        {/* Total Brokers */}
        {insights.totalBrokers != null && (
            <div className="col">
                <div className="card shadow-none border bg-gradient-start-1 h-100">
                    <div className="card-body p-20">
                        <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                            <div>
                                <p className="fw-medium text-primary-light mb-1">Total Brokers</p>
                                <h6 className="mb-0">{formatNumber(insights.totalBrokers)}</h6>
                            </div>
                            <div className="w-50-px h-50-px bg-cyan rounded-circle d-flex justify-content-center align-items-center">
                                <Icon icon="bi:people-fill" className="text-white text-2xl mb-0" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )}
                    {/* Total Developers */}
                    {insights.totalApprovedDevelopers != null && (
                        <div className="col">
                            <div className="card shadow-none border bg-gradient-start-1 h-100">
                                <div className="card-body p-20">
                                    <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                                        <div>
                                            <p className="fw-medium text-primary-light mb-1">Total Developers</p>
                                            <h6 className="mb-0">{formatNumber(insights.totalApprovedDevelopers)}</h6>
                                        </div>
                                        <div className="w-50-px h-50-px bg-cyan rounded-circle d-flex justify-content-center align-items-center">
                                            <Icon icon="bi:people-fill" className="text-white text-2xl mb-0" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                    {/* Total Pending Dev Sales */}
                    {insights.totalPendingDeveloperSales != null && (
                        <div className="col">
                            <div className="card shadow-none border bg-gradient-start-1 h-100">
                                <div className="card-body p-20">
                                    <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                                        <div>
                                            <p className="fw-medium text-primary-light mb-1">Pending Developer Sales</p>
                                            <h6 className="mb-0">{formatNumber(insights.totalPendingDeveloperSales)}</h6>
                                        </div>
                                        <div className="w-50-px h-50-px bg-yellow rounded-circle d-flex justify-content-center align-items-center">
                                            <Icon icon="bi:people-fill" className="text-white text-2xl mb-0" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                    {/* Total Deletion Requests */}
                    {insights.totalDeletionRequests != null && (
                        <div className="col">
                            <div className="card shadow-none border bg-gradient-start-8 h-100">
                                <div className="card-body p-20">
                                    <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                                        <div>
                                            <p className="fw-medium text-primary-light mb-1">Total Deletion Requests</p>
                                            <h6 className="mb-0">{formatNumber(insights.totalDeletionRequests)}</h6>
                                        </div>
                                        <div className="w-50-px h-50-px bg-danger rounded-circle d-flex justify-content-center align-items-center">
                                            <Icon icon="fa6-solid:ban" className="text-white text-2xl mb-0" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                    {/* Total Approvals */}
                    {insights.totalApprovals != null && (
                        <div className="col">
                            <div className="card shadow-none border bg-gradient-start-5 h-100">
                                <div className="card-body p-20">
                                    <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                                        <div>
                                            <p className="fw-medium text-primary-light mb-1">Total Pending Approvals</p>
                                            <h6 className="mb-0">{formatNumber(insights.totalApprovals)}</h6>
                                        </div>
                                        <div className="w-50-px h-50-px bg-yellow rounded-circle d-flex justify-content-center align-items-center">
                                            <Icon icon="bi:clock-fill" className="text-white text-2xl mb-0" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

        {/* Total Developer Sales */}
        {insights.totalDeveloperSales != null && (
            <div className="col">
                <div className="card shadow-none border bg-gradient-start-2 h-100">
                    <div className="card-body p-20">
                        <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                            <div>
                                <p className="fw-medium text-primary-light mb-1">Total Developer Sales</p>
                                <h6 className="mb-0">{formatNumber(insights.totalDeveloperSales)}</h6>
                            </div>
                            <div className="w-50-px h-50-px bg-purple rounded-circle d-flex justify-content-center align-items-center">
                                <Icon icon="fa6-solid:user-tie" className="text-white text-2xl mb-0" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )}

        {/* Total Projects */}
        {insights.totalProjects != null && (
            <div className="col">
                <div className="card shadow-none border bg-gradient-start-3 h-100">
                    <div className="card-body p-20">
                        <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                            <div>
                                <p className="fw-medium text-primary-light mb-1">Total Projects</p>
                                <h6 className="mb-0">{formatNumber(insights.totalProjects)}</h6>
                            </div>
                            <div className="w-50-px h-50-px bg-info rounded-circle d-flex justify-content-center align-items-center">
                                <Icon icon="mdi:office-building" className="text-white text-2xl mb-0" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )}
                    {/* Total Units */}
                    {insights.totalUnits != null && (
                        <div className="col">
                            <div className="card shadow-none border bg-gradient-start-3 h-100">
                                <div className="card-body p-20">
                                    <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                                        <div>
                                            <p className="fw-medium text-primary-light mb-1">Total Units</p>
                                            <h6 className="mb-0">{formatNumber(insights.totalUnits)}</h6>
                                        </div>
                                        <div className="w-50-px h-50-px bg-info rounded-circle d-flex justify-content-center align-items-center">
                                            <Icon icon="mdi:office-building" className="text-white text-2xl mb-0" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

        {/* Total Approved CILs Deal Value */}
        {insights.totalApprovedCILsDealValues != null && (
            <div className="col">
                <div className="card shadow-none border bg-gradient-start-4 h-100">
                    <div className="card-body p-20">
                        <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                            <div>
                                <p className="fw-medium text-primary-light mb-1">Total Approved CILs Deal Value</p>
                                <h6 className="mb-0">{formatNumber(insights.totalApprovedCILsDealValues.sum)}</h6>
                            </div>
                            <div className="w-50-px h-50-px bg-warning rounded-circle d-flex justify-content-center align-items-center">
                                <Icon icon="fa6-solid:money-check-dollar" className="text-white text-2xl mb-0" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )}

        {/* Total Pending CILs */}
        {insights.totalPendingCILs != null && (
            <div className="col">
                <div className="card shadow-none border bg-gradient-start-5 h-100">
                    <div className="card-body p-20">
                        <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                            <div>
                                <p className="fw-medium text-primary-light mb-1">Total Pending CILs</p>
                                <h6 className="mb-0">{formatNumber(insights.totalPendingCILs)}</h6>
                            </div>
                            <div className="w-50-px h-50-px bg-secondary rounded-circle d-flex justify-content-center align-items-center">
                                <Icon icon="fa6-solid:clock" className="text-white text-2xl mb-0" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )}

        {/* Total Rejected CILs */}
        {insights.totalRejectedCILs != null && (
            <div className="col">
                <div className="card shadow-none border bg-gradient-start-6 h-100">
                    <div className="card-body p-20">
                        <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                            <div>
                                <p className="fw-medium text-primary-light mb-1">Total Rejected CILs</p>
                                <h6 className="mb-0">{formatNumber(insights.totalRejectedCILs)}</h6>
                            </div>
                            <div className="w-50-px h-50-px bg-danger rounded-circle d-flex justify-content-center align-items-center">
                                <Icon icon="fa6-solid:ban" className="text-white text-2xl mb-0" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )}

        {/* Total Pending Withdrawals */}
        {insights.totalPendingWithdrawals != null && (
            <div className="col">
                <div className="card shadow-none border bg-gradient-start-7 h-100">
                    <div className="card-body p-20">
                        <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                            <div>
                                <p className="fw-medium text-primary-light mb-1">Total Pending Withdrawals</p>
                                <h6 className="mb-0">{formatNumber(insights.totalPendingWithdrawals.count)}</h6>
                            </div>
                            <div className="w-50-px h-50-px bg-warning rounded-circle d-flex justify-content-center align-items-center">
                                <Icon icon="fa6-solid:hourglass" className="text-white text-2xl mb-0" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )}

        {/* Total Commission Paid */}
        {insights.totalCommissionPaid != null && (
            <div className="col">
                <div className="card shadow-none border bg-gradient-start-8 h-100">
                    <div className="card-body p-20">
                        <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                            <div>
                                <p className="fw-medium text-primary-light mb-1">Total Commission Paid</p>
                                <h6 className="mb-0">{formatNumber(insights.totalCommissionPaid)}</h6>
                            </div>
                            <div className="w-50-px h-50-px bg-success rounded-circle d-flex justify-content-center align-items-center">
                                <Icon icon="fa6-solid:coins" className="text-white text-2xl mb-0" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )}

        {/* Total Platform Balance */}
        {insights.totalPlatformBalance != null && (
            <div className="col">
                <div className="card shadow-none border bg-gradient-start-9 h-100">
                    <div className="card-body p-20">
                        <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                            <div>
                                <p className="fw-medium text-primary-light mb-1">Total Platform Balance</p>
                                <h6 className="mb-0">{formatNumber(insights.totalPlatformBalance)}</h6>
                            </div>
                            <div className="w-50-px h-50-px bg-dark rounded-circle d-flex justify-content-center align-items-center">
                                <Icon icon="fa6-solid:wallet" className="text-white text-2xl mb-0" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )}

        {/* Top Wallet By Balance */}
        {insights.topWalletByBalance != null && (
            <div className="col">
                <div className="card shadow-none border bg-gradient-start-10 h-100">
                    <div className="card-body p-20">
                        <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                            <div>
                                <p className="fw-medium text-primary-light mb-1">Top Wallet By Balance</p>
                                <h6 className="mb-0">{formatNumber(insights.topWalletByBalance.totalBalance)}</h6>
                            </div>
                            <div className="w-50-px h-50-px bg-info rounded-circle d-flex justify-content-center align-items-center">
                                <Icon icon="fa6-solid:credit-card" className="text-white text-2xl mb-0" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )}

        {/* Active Users Last 24 Hours */}
        {insights.activeUsers?.last24Hours != null && (
            <div className="col">
                <div className="card shadow-none border bg-gradient-start-11 h-100">
                    <div className="card-body p-20">
                        <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                            <div>
                                <p className="fw-medium text-primary-light mb-1">Active Users (24h)</p>
                                <h6 className="mb-0">{formatNumber(insights.activeUsers.last24Hours)}</h6>
                            </div>
                            <div className="w-50-px h-50-px bg-success rounded-circle d-flex justify-content-center align-items-center">
                                <Icon icon="mdi:account-group" className="text-white text-2xl mb-0" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )}

        {/* Active Users Last 7 Days */}
        {insights.activeUsers?.last7Days != null && (
            <div className="col">
                <div className="card shadow-none border bg-gradient-start-12 h-100">
                    <div className="card-body p-20">
                        <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                            <div>
                                <p className="fw-medium text-primary-light mb-1">Active Users (7d)</p>
                                <h6 className="mb-0">{formatNumber(insights.activeUsers.last7Days)}</h6>
                            </div>
                            <div className="w-50-px h-50-px bg-info rounded-circle d-flex justify-content-center align-items-center">
                                <Icon icon="mdi:account-group" className="text-white text-2xl mb-0" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )}
    </>
)}


            {/* ----- CARDS COMMON TO BOTH ADMIN AND DEVELOPER SALES ----- */}

            {/* Total CILs */}
            {insights.totalCILs != null && (
                <div className="col">
                    <div className="card shadow-none border bg-gradient-start-4 h-100">
                        <div className="card-body p-20">
                            <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                                <div>
                                    <p className="fw-medium text-primary-light mb-1">Total CILs</p>
                                    <h6 className="mb-0">{formatNumber(insights.totalCILs)}</h6>
                                </div>
                                <div className="w-50-px h-50-px bg-success-main rounded-circle d-flex justify-content-center align-items-center">
                                    <Icon icon="mdi:note-text" className="text-white text-2xl mb-0" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Total EOIs */}
            {insights.totalEOIs != null && (
                <div className="col">
                    <div className="card shadow-none border bg-gradient-start-5 h-100">
                        <div className="card-body p-20">
                            <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                                <div>
                                    <p className="fw-medium text-primary-light mb-1">Total EOIs</p>
                                    <h6 className="mb-0">{formatNumber(insights.totalEOIs)}</h6>
                                </div>
                                <div className="w-50-px h-50-px bg-red rounded-circle d-flex justify-content-center align-items-center">
                                    <Icon icon="mdi:hand-coin" className="text-white text-2xl mb-0" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Approved CILs */}
            {insights.totalApprovedCILs != null && (
                <div className="col">
                    <div className="card shadow-none border bg-gradient-start-1 h-100">
                        <div className="card-body p-20">
                            <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                                <div>
                                    <p className="fw-medium text-primary-light mb-1">Approved CILs</p>
                                    <h6 className="mb-0">{formatNumber(insights.totalApprovedCILs.count)}</h6>
                                </div>
                                <div className="w-50-px h-50-px bg-cyan rounded-circle d-flex justify-content-center align-items-center">
                                    <Icon icon="mdi:check-decagram" className="text-white text-2xl mb-0" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* ----- DEVELOPER SALES ONLY CARDS ----- */}
            {userType === "developerSales" && insights && ( // Check insights object exists
                <>
                    {/* Total Brokers */}
                    {insights.summary?.totalBrokers != null && (
                        <div className="col">
                            <div className="card shadow-none border bg-gradient-start-1 h-100">
                                <div className="card-body p-20">
                                    <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                                        <div>
                                            <p className="fw-medium text-primary-light mb-1">Total Brokers On Platform</p>
                                            <h6 className="mb-0">{formatNumber(insights.summary.totalBrokers)}</h6>
                                        </div>
                                        <div className="w-50-px h-50-px bg-cyan rounded-circle d-flex justify-content-center align-items-center">
                                            <Icon icon="bi:people-fill" className="text-white text-2xl mb-0" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                    {/* Total Projects (Developer) */}
                    {insights.summary?.totalProjects != null && (
                        <div className="col">
                            <div className="card shadow-none border bg-gradient-start-3 h-100"> {/* Unique bg color */}
                                <div className="card-body p-20">
                                    <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                                        <div>
                                            <p className="fw-medium text-primary-light mb-1">My Total Projects</p>
                                            <h6 className="mb-0">{formatNumber(insights.summary.totalProjects)}</h6>
                                        </div>
                                        <div className="w-50-px h-50-px bg-info rounded-circle d-flex justify-content-center align-items-center">
                                            <Icon icon="mdi:office-building-marker" className="text-white text-2xl mb-0" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                    

                    {/* Total Units (Developer) - Already Existed, adjusted access */}
                    {insights.summary?.totalUnits != null && (
                        <div className="col">
                            <div className="card shadow-none border bg-gradient-start-2 h-100">
                                <div className="card-body p-20">
                                    <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                                        <div>
                                            <p className="fw-medium text-primary-light mb-1">My Total Units</p>
                                            <h6 className="mb-0">{formatNumber(insights.summary.totalUnits)}</h6>
                                        </div>
                                        <div className="w-50-px h-50-px bg-purple rounded-circle d-flex justify-content-center align-items-center">
                                            <Icon icon="mdi:home-group" className="text-white text-2xl mb-0" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* Total EOIs (Developer) */}
                    {insights.summary?.totalEOIs != null && (
                        <div className="col">
                            <div className="card shadow-none border bg-gradient-start-5 h-100">
                                <div className="card-body p-20">
                                    <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                                        <div>
                                            <p className="fw-medium text-primary-light mb-1">My Total EOIs</p>
                                            <h6 className="mb-0">{formatNumber(insights.summary.totalEOIs)}</h6>
                                        </div>
                                        <div className="w-50-px h-50-px bg-red rounded-circle d-flex justify-content-center align-items-center">
                                            <Icon icon="mdi:hand-coin-outline" className="text-white text-2xl mb-0" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* Approved CILs (Developer) */}
                    {insights.cilStatusBreakdown?.approved != null && (
                        <div className="col">
                            <div className="card shadow-none border bg-gradient-start-1 h-100"> {/* Changed color */}
                                <div className="card-body p-20">
                                    <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                                        <div>
                                            <p className="fw-medium text-primary-light mb-1">My Approved CILs</p>
                                            <h6 className="mb-0">{formatNumber(insights.cilStatusBreakdown.approved)}</h6>
                                        </div>
                                        <div className="w-50-px h-50-px bg-cyan rounded-circle d-flex justify-content-center align-items-center">
                                            <Icon icon="mdi:check-decagram-outline" className="text-white text-2xl mb-0" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* Pending CILs (Developer) */}
                    {insights.cilStatusBreakdown?.pending != null && (
                        <div className="col">
                            <div className="card shadow-none border bg-gradient-start-7 h-100"> {/* Changed color */}
                                <div className="card-body p-20">
                                    <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                                        <div>
                                            <p className="fw-medium text-primary-light mb-1">My Pending CILs</p>
                                            <h6 className="mb-0">{formatNumber(insights.cilStatusBreakdown.pending)}</h6>
                                        </div>
                                        <div className="w-50-px h-50-px bg-orange rounded-circle d-flex justify-content-center align-items-center"> {/* Changed color */}
                                            <Icon icon="mdi:clock-alert-outline" className="text-white text-2xl mb-0" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* Rejected CILs (Developer) */}
                    {insights.cilStatusBreakdown?.rejected != null && (
                        <div className="col">
                            <div className="card shadow-none border bg-gradient-start-6 h-100"> {/* Changed color */}
                                <div className="card-body p-20">
                                    <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                                        <div>
                                            <p className="fw-medium text-primary-light mb-1">My Rejected CILs</p>
                                            <h6 className="mb-0">{formatNumber(insights.cilStatusBreakdown.rejected)}</h6>
                                        </div>
                                        <div className="w-50-px h-50-px bg-danger rounded-circle d-flex justify-content-center align-items-center">
                                            <Icon icon="mdi:cancel" className="text-white text-2xl mb-0" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* Total Sales Count (Developer) */}
                    {insights.salesPerformance?.totalSalesCount != null && (
                        <div className="col">
                            <div className="card shadow-none border bg-gradient-start-8 h-100"> {/* Changed color */}
                                <div className="card-body p-20">
                                    <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                                        <div>
                                            <p className="fw-medium text-primary-light mb-1">My Total Sales Count</p>
                                            <h6 className="mb-0">{formatNumber(insights.salesPerformance.totalSalesCount)}</h6>
                                        </div>
                                        <div className="w-50-px h-50-px bg-success rounded-circle d-flex justify-content-center align-items-center">
                                            <Icon icon="mdi:counter" className="text-white text-2xl mb-0" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* Total Sales Value (Developer) */}
                    {insights.salesPerformance?.totalSalesValue != null && (
                        <div className="col">
                            <div className="card shadow-none border bg-gradient-start-4 h-100"> {/* Changed color */}
                                <div className="card-body p-20">
                                    <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                                        <div>
                                            <p className="fw-medium text-primary-light mb-1">My Total Sales Value</p>
                                            <h6 className="mb-0">{formatNumber(insights.salesPerformance.totalSalesValue, true)}</h6> {/* Format as currency */}
                                        </div>
                                        <div className="w-50-px h-50-px bg-warning rounded-circle d-flex justify-content-center align-items-center">
                                            <Icon icon="mdi:cash-multiple" className="text-white text-2xl mb-0" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* Average Sale Value (Developer) */}
                    {insights.salesPerformance?.averageSaleValue != null && (
                        <div className="col">
                            <div className="card shadow-none border bg-gradient-start-10 h-100"> {/* Changed color */}
                                <div className="card-body p-20">
                                    <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                                        <div>
                                            <p className="fw-medium text-primary-light mb-1">My Average Sale Value</p>
                                            <h6 className="mb-0">{formatNumber(insights.salesPerformance.averageSaleValue, true)}</h6> {/* Format as currency */}
                                        </div>
                                        <div className="w-50-px h-50-px bg-lime rounded-circle d-flex justify-content-center align-items-center"> {/* Changed color */}
                                            <Icon icon="mdi:scale-balance" className="text-white text-2xl mb-0" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </>
            )}
        </div>
    );
};

export default UnitCountOne;
